export default function genericMapper<T = any>() {
	return {
		getProperties(context: any): T {
			return context.get();
		}
	}
}



// WEBPACK FOOTER //
// ./~/@dojo/cli-build-webpack/loaders/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/framework/util/genericMapper.ts